module.exports = __webpack_public_path__ + "img/8ae3fd8.jpg";